import { render, staticRenderFns } from "./NswImoFormFooterBtns.vue?vue&type=template&id=50111d2a"
import script from "./NswImoFormFooterBtns.vue?vue&type=script&lang=js"
export * from "./NswImoFormFooterBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports